import logInit from './common/log-util';

// 日志初始化
logInit();

// 日期格式化初始化

/**
 * @description 获取浏览器默认语言
 * @returns {String}
 */
export function getBrowserLang() {
  const browserLang = navigator.language
    ? navigator.language
    : navigator.browserLanguage;
  let defaultBrowserLang = '';
  if (['cn', 'zh', 'zh-cn'].includes(browserLang.toLowerCase())) {
    defaultBrowserLang = 'zh';
  } else {
    defaultBrowserLang = 'en';
  }
  return defaultBrowserLang;
}
/**
 * @description 获取当前时间对应的提示语
 * @returns {String}
 */
export function getTimeState() {
  const timeNow = new Date();
  const hours = timeNow.getHours();
  if (hours >= 6 && hours <= 10) return `早上好 ⛅`;
  if (hours >= 10 && hours <= 14) return `中午好 🌞`;
  if (hours >= 14 && hours <= 18) return `下午好 🌞`;
  if (hours >= 18 && hours <= 24) return `晚上好 🌛`;
  if (hours >= 0 && hours <= 6) return `凌晨好 🌛`;
  return '';
}

export function isEmpty(value) {
  // 1. 处理 undefined 和 null
  if (value === undefined || value === null) {
    return true;
  }

  // 2. 处理字符串（包括空白字符）
  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  // 3. 处理数组
  if (Array.isArray(value)) {
    return value.length === 0;
  }

  // 4. 处理普通对象（不包括 Date/RegExp 等特殊对象）
  if (
    typeof value === 'object' &&
    Object.prototype.toString.call(value) === '[object Object]'
  ) {
    return Object.keys(value).length === 0;
  }

  // 5. 其他类型（数字/布尔值/函数等）均视为非空
  return false;
}

export function isAllPropertiesEmpty(obj) {
  // 1. 处理null和undefined
  if (obj == null) return true;

  // 2. 处理非对象类型（如数字、布尔值等）
  if (typeof obj !== 'object' && typeof obj !== 'function') {
    return false; // 基本类型（非空）不为空
  }

  // 3. 获取对象所有自有属性（包括Symbol属性）
  const keys = Reflect.ownKeys(obj);

  // 4. 若无属性，直接返回true（空对象）
  if (keys.length === 0) return true;

  // 5. 遍历所有属性值，递归检测是否为空
  return keys.every((key) => {
    const value = obj[key];
    return isEmpty(value); // 调用空值检测函数
  });
}
